/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetServiceprovider200ResponseReseller } from './GetServiceprovider200ResponseReseller';
import {
    GetServiceprovider200ResponseResellerFromJSON,
    GetServiceprovider200ResponseResellerFromJSONTyped,
    GetServiceprovider200ResponseResellerToJSON,
    GetServiceprovider200ResponseResellerToJSONTyped,
} from './GetServiceprovider200ResponseReseller';
import type { GetServiceprovider200ResponseWhitelabel } from './GetServiceprovider200ResponseWhitelabel';
import {
    GetServiceprovider200ResponseWhitelabelFromJSON,
    GetServiceprovider200ResponseWhitelabelFromJSONTyped,
    GetServiceprovider200ResponseWhitelabelToJSON,
    GetServiceprovider200ResponseWhitelabelToJSONTyped,
} from './GetServiceprovider200ResponseWhitelabel';
import type { GetServiceprovider200ResponseCustomEmail } from './GetServiceprovider200ResponseCustomEmail';
import {
    GetServiceprovider200ResponseCustomEmailFromJSON,
    GetServiceprovider200ResponseCustomEmailFromJSONTyped,
    GetServiceprovider200ResponseCustomEmailToJSON,
    GetServiceprovider200ResponseCustomEmailToJSONTyped,
} from './GetServiceprovider200ResponseCustomEmail';
import type { GetServiceprovider200ResponseLicense } from './GetServiceprovider200ResponseLicense';
import {
    GetServiceprovider200ResponseLicenseFromJSON,
    GetServiceprovider200ResponseLicenseFromJSONTyped,
    GetServiceprovider200ResponseLicenseToJSON,
    GetServiceprovider200ResponseLicenseToJSONTyped,
} from './GetServiceprovider200ResponseLicense';
import type { GetServiceprovider200ResponseQuickcheck } from './GetServiceprovider200ResponseQuickcheck';
import {
    GetServiceprovider200ResponseQuickcheckFromJSON,
    GetServiceprovider200ResponseQuickcheckFromJSONTyped,
    GetServiceprovider200ResponseQuickcheckToJSON,
    GetServiceprovider200ResponseQuickcheckToJSONTyped,
} from './GetServiceprovider200ResponseQuickcheck';

/**
 * Serviceprovider details
 * @export
 * @interface GetServiceprovider200Response
 */
export interface GetServiceprovider200Response {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderId: string;
    /**
     * Display name of the serviceprovider organization.
     */
    serviceproviderName: string;
    /**
     * 
     */
    whitelabel: GetServiceprovider200ResponseWhitelabel;
    /**
     * 
     */
    quickcheck: GetServiceprovider200ResponseQuickcheck;
    /**
     * 
     */
    customEmail: GetServiceprovider200ResponseCustomEmail;
    /**
     * Number of clients associated with this serviceprovider.
     */
    clientCount: number;
    /**
     * Whether exact per-client billing is enabled.
     */
    exactBilling: boolean;
    /**
     * Whether the new pricing model is active for this serviceprovider.
     */
    newPricing?: boolean;
    /**
     * 
     */
    license: GetServiceprovider200ResponseLicense;
    /**
     * 
     */
    reseller: GetServiceprovider200ResponseReseller;
}

/**
 * Check if a given object implements the GetServiceprovider200Response interface.
 */
export function instanceOfGetServiceprovider200Response(value: object): value is GetServiceprovider200Response {
    if (!('serviceproviderId' in value) || value['serviceproviderId'] === undefined) return false;
    if (!('serviceproviderName' in value) || value['serviceproviderName'] === undefined) return false;
    if (!('whitelabel' in value) || value['whitelabel'] === undefined) return false;
    if (!('quickcheck' in value) || value['quickcheck'] === undefined) return false;
    if (!('customEmail' in value) || value['customEmail'] === undefined) return false;
    if (!('clientCount' in value) || value['clientCount'] === undefined) return false;
    if (!('exactBilling' in value) || value['exactBilling'] === undefined) return false;
    if (!('license' in value) || value['license'] === undefined) return false;
    if (!('reseller' in value) || value['reseller'] === undefined) return false;
    return true;
}

export function GetServiceprovider200ResponseFromJSON(json: any): GetServiceprovider200Response {
    return GetServiceprovider200ResponseFromJSONTyped(json, false);
}

export function GetServiceprovider200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceprovider200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceproviderId': json['serviceproviderId'],
        'serviceproviderName': json['serviceproviderName'],
        'whitelabel': GetServiceprovider200ResponseWhitelabelFromJSON(json['whitelabel']),
        'quickcheck': GetServiceprovider200ResponseQuickcheckFromJSON(json['quickcheck']),
        'customEmail': GetServiceprovider200ResponseCustomEmailFromJSON(json['customEmail']),
        'clientCount': json['clientCount'],
        'exactBilling': json['exactBilling'],
        'newPricing': json['newPricing'] == null ? undefined : json['newPricing'],
        'license': GetServiceprovider200ResponseLicenseFromJSON(json['license']),
        'reseller': GetServiceprovider200ResponseResellerFromJSON(json['reseller']),
    };
}

export function GetServiceprovider200ResponseToJSON(json: any): GetServiceprovider200Response {
    return GetServiceprovider200ResponseToJSONTyped(json, false);
}

export function GetServiceprovider200ResponseToJSONTyped(value?: GetServiceprovider200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceproviderId': value['serviceproviderId'],
        'serviceproviderName': value['serviceproviderName'],
        'whitelabel': GetServiceprovider200ResponseWhitelabelToJSON(value['whitelabel']),
        'quickcheck': GetServiceprovider200ResponseQuickcheckToJSON(value['quickcheck']),
        'customEmail': GetServiceprovider200ResponseCustomEmailToJSON(value['customEmail']),
        'clientCount': value['clientCount'],
        'exactBilling': value['exactBilling'],
        'newPricing': value['newPricing'],
        'license': GetServiceprovider200ResponseLicenseToJSON(value['license']),
        'reseller': GetServiceprovider200ResponseResellerToJSON(value['reseller']),
    };
}

